<template>
  <div class="library">
    <c-page-turner />
    <md-tabs class="tabs">
      <md-tab id="tab-all" :md-label="$t('all')" exact>
        <c-led-list class="list" :query="{ ordering: '-id' }" />
      </md-tab>
      <md-tab id="tab-hot" :md-label="$t('hot')">
        <c-led-list class="list" :query="{ ordering: '-like_count' }" />
      </md-tab>
    </md-tabs>
  </div>
</template>
<script>
export default {
  name: "Library",
  data() {
    return {};
  },
};
</script>
<style lang="scss">
.library {
  width: 100%;
  height: inherit;
  .tabs {
    .md-tabs-navigation {
      @include flex-center;
      padding: 15px 0;
      margin-top: 20px;

      .md-tab-nav-button {
        margin: 0 60px;
        border-radius: 10px;

        &.md-active {
          background: $primary-color;
        }

        .md-button-content {
          font-size: 20px;
          text-transform: none;
        }
      }

      .md-tabs-indicator {
        display: none;
      }
    }

    .list {
      width: 1200px;
      height: calc(100vh - 200px - #{$header-height} - #{$footer-height});
      margin: 0 auto;
    }
  }
}
</style>
